<template>
    <div>
        <v-btn text :to="{ name: 'admin-settings', query: { tab: '1' } }" class="mb-4">
            <v-icon left>{{ icons.mdiArrowLeft }}</v-icon>
            {{ $t('Palautteiden luokittelu') }}
        </v-btn>

        <feedback-category-form :id="id" @saved="onSaved"></feedback-category-form>
    </div>
</template>

<script>
import { useRouter } from '@core/utils';
import { mdiArrowLeft } from '@mdi/js';
import feedbackCategoryForm from './components/feedback_category_form.vue';

export default {
    components: {
        feedbackCategoryForm,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    setup() {
        const { router } = useRouter();

        const onSaved = () => {
            router.push({ name: 'admin-settings', query: { tab: '1' } });
        };

        return {
            onSaved,
            icons: {
                mdiArrowLeft,
            },
        };
    },
};
</script>
